import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '@/api/client'
import { Button, Card, FormRow, Input } from '@/admin-design/_common'

export default function Login() {
  const nav = useNavigate()
  const [email, setEmail] = useState('')
  const [pass, setPass] = useState('')
  const [err, setErr] = useState('')
  const [loading, setLoading] = useState(false)

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setErr('')
    setLoading(true)
    try {
      await api.login(email, pass)
      nav('/')
    } catch {
      setErr('로그인 실패 — 이메일/비밀번호를 확인하세요')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <Card className="w-80 shadow-sm">
        <form onSubmit={onSubmit} className="p-6 space-y-4">
          <h1 className="text-lg font-semibold text-card-foreground">ScriptDirector Admin</h1>
          <FormRow label="이메일" required stacked>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </FormRow>
          <FormRow label="비밀번호" required stacked>
            <Input
              type="password"
              value={pass}
              onChange={(e) => setPass(e.target.value)}
              required
              autoComplete="current-password"
            />
          </FormRow>
          {err && <p className="text-sm text-destructive">{err}</p>}
          <Button type="submit" variant="primary" className="w-full" loading={loading}>
            {loading ? 'Signing in…' : 'Login'}
          </Button>
        </form>
      </Card>
    </div>
  )
}
